/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';

const UruguayDashboardView = () =>
  import('./components/UruguayDashboardView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/uruguay'),
    name: 'uruguay_dashboard_view',
    component: UruguayDashboardView,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
